/** Footer Telegram social icon — main IDX community channel */
export const IDX_TELEGRAM_OFFICIAL_URL = "https://t.me/IDX_Official";

/** IDX AutoBot Telegram Mini App — open bot in Telegram */
export const IDX_TELEGRAM_BOT_URL = "https://t.me/IDX_AutoBot";

/** Opens the Main Mini App (not a chat-only deep link). */
export const IDX_TELEGRAM_BOT_MINI_APP_URL = `${IDX_TELEGRAM_BOT_URL}?startapp`;

/** AI support human handoff — @IDX_SupportBot */
export const IDX_TELEGRAM_SUPPORT_URL = "https://t.me/IDX_SupportBot";
